'use client';

import { ArchiveReasonGroup } from '@/app/[lang]/(main)/components/shared/StoppingReasonSelector';
import { useModals } from '@/contexts/ModalContext';
import { ArchiveTelegramProductDtoReasonEnum } from '@/generated';
import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

type Props = {
  onSave: (reason: ArchiveTelegramProductDtoReasonEnum, text?: string) => void;
};

export const ProductStoppingModal: React.FC<Props> = ({ onSave }) => {
  const modals = useModals();
  const t = useTranslations('modals');

  const onClose = () => {
    modals.close(`archiving-reason-modal`);
  };
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('stopping.header')}</DialogTitle>
        </DialogHeader>
        <ArchiveReasonGroup defaultValue={'SoldHere'} onSave={onSave} />
      </DialogContent>
    </Dialog>
  );
};
